(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('handbook', {
            parent: 'entity',
            url: '/handbook?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'teJHipsterApp.handbook.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/handbook/handbooks.html',
                    controller: 'HandbookController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('handbook');
                    $translatePartialLoader.addPart('handbookDocumentType');
                    $translatePartialLoader.addPart('documentDataType');
                    $translatePartialLoader.addPart('handbookVisibleFor');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('handbook-detail', {
            parent: 'handbook',
            url: '/handbook/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'teJHipsterApp.handbook.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/handbook/handbook-detail.html',
                    controller: 'HandbookDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('handbook');
                    $translatePartialLoader.addPart('handbookDocumentType');
                    $translatePartialLoader.addPart('documentDataType');
                    $translatePartialLoader.addPart('handbookVisibleFor');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Handbook', function($stateParams, Handbook) {
                    return Handbook.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'handbook',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('handbook-detail.edit', {
            parent: 'handbook-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/handbook/handbook-dialog.html',
                    controller: 'HandbookDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Handbook', function(Handbook) {
                            return Handbook.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('handbook.new', {
            parent: 'handbook',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/handbook/handbook-dialog.html',
                    controller: 'HandbookDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                documentType: null,
                                name: null,
                                isTemplate: null,
                                isPublic: null,
                                documentDataType: null,
                                additionalInfo: null,
                                visibleFor: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('handbook', null, { reload: 'handbook' });
                }, function() {
                    $state.go('handbook');
                });
            }]
        })
        .state('handbook.edit', {
            parent: 'handbook',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/handbook/handbook-dialog.html',
                    controller: 'HandbookDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Handbook', function(Handbook) {
                            return Handbook.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('handbook', null, { reload: 'handbook' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('handbook.delete', {
            parent: 'handbook',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/handbook/handbook-delete-dialog.html',
                    controller: 'HandbookDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Handbook', function(Handbook) {
                            return Handbook.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('handbook', null, { reload: 'handbook' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
